/* =========================
   Artist 1 – Renuka Sondhi
   ========================= */

import renukaCover from "./assets/artworks/RenukaSondhi/RenukaSondhi_cover.jpg";
import renukaWork1 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work1.jpg";
import renukaWork2 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work2.jpg";
import renukaWork3 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work3.jpg";
import renukaWork4 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work4.jpg";
import renukaWork5 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work5.jpg";
import renukaWork6 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work6.jpg";
import renukaWork7 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work7.jpg";
import renukaWork8 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work8.jpg";
import renukaWork9 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work9.jpg";
import renukaWork10 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work10.jpg";
import renukaWork11 from "./assets/artworks/RenukaSondhi/RenukaSondhi_work11.jpg";

/* =========================
   Artist 2 – Alka Jhamb
   ========================= */

import alkaCover from "./assets/artworks/AlkaJhamb/AlkaJhamb_cover.jpeg";
import alkaWork1 from "./assets/artworks/AlkaJhamb/AlkaJhamb_work1.jpeg";
import alkaWork2 from "./assets/artworks/AlkaJhamb/AlkaJhamb_work2.jpeg";
import alkaWork3 from "./assets/artworks/AlkaJhamb/AlkaJhamb_work3.jpeg";
import alkaWork4 from "./assets/artworks/AlkaJhamb/AlkaJhamb_work4.jpeg";

/* =========================
   Artist 3 – Satish Sharma
   ========================= */

import satishCover from "./assets/artworks/SatishSharma/SatishSharma_cover.jpg";
import satishWork1 from "./assets/artworks/SatishSharma/SatishSharma_work1.jpg";
import satishWork2 from "./assets/artworks/SatishSharma/SatishSharma_work2.jpg";
import satishWork3 from "./assets/artworks/SatishSharma/SatishSharma_work3.jpg";
import satishWork4 from "./assets/artworks/SatishSharma/SatishSharma_work4.jpg";

/* =========================
   Artist 4 – Anandamoy Banerji
   ========================= */

/* Batch 1 */
import abCover1 from "./assets/artworks/AnandamoyBanerji/batch1/AnandamoyBanerji_cover1.jpg";
import abWork1 from "./assets/artworks/AnandamoyBanerji/batch1/AnandamoyBanerji_work1.jpg";
import abWork2 from "./assets/artworks/AnandamoyBanerji/batch1/AnandamoyBanerji_work2.jpg";
import abWork3 from "./assets/artworks/AnandamoyBanerji/batch1/AnandamoyBanerji_work3.jpg";
import abWork4 from "./assets/artworks/AnandamoyBanerji/batch1/AnandamoyBanerji_work4.jpg";
import abWork5 from "./assets/artworks/AnandamoyBanerji/batch1/AnandamoyBanerji_work5.jpg";
import abWork6 from "./assets/artworks/AnandamoyBanerji/batch1/AnandamoyBanerji_work6.jpg";
import abWork7 from "./assets/artworks/AnandamoyBanerji/batch1/AnandamoyBanerji_work7.jpg";
import abWork8 from "./assets/artworks/AnandamoyBanerji/batch1/AnandamoyBanerji_work8.jpg";
import abWork9 from "./assets/artworks/AnandamoyBanerji/batch1/AnandamoyBanerji_work9.jpg";

/* Batch 2 */
import abCover2 from "./assets/artworks/AnandamoyBanerji/batch2/AnandamoyBanerji_cover2.jpg";
import abWork10 from "./assets/artworks/AnandamoyBanerji/batch2/AnandamoyBanerji_work10.jpg";
import abWork11 from "./assets/artworks/AnandamoyBanerji/batch2/AnandamoyBanerji_work11.jpg";
import abWork12 from "./assets/artworks/AnandamoyBanerji/batch2/AnandamoyBanerji_work12.jpg";
import abWork13 from "./assets/artworks/AnandamoyBanerji/batch2/AnandamoyBanerji_work13.jpg";
import abWork14 from "./assets/artworks/AnandamoyBanerji/batch2/AnandamoyBanerji_work14.jpg";
import abWork15 from "./assets/artworks/AnandamoyBanerji/batch2/AnandamoyBanerji_work15.jpg";
import abWork16 from "./assets/artworks/AnandamoyBanerji/batch2/AnandamoyBanerji_work16.jpg";
import abWork17 from "./assets/artworks/AnandamoyBanerji/batch2/AnandamoyBanerji_work17.jpg";
import abWork18 from "./assets/artworks/AnandamoyBanerji/batch2/AnandamoyBanerji_work18.jpg";

/* Batch 3 */
import abCover3 from "./assets/artworks/AnandamoyBanerji/batch3/AnandamoyBanerji_cover3.jpg";
import abWork19 from "./assets/artworks/AnandamoyBanerji/batch3/AnandamoyBanerji_work19.jpg";
import abWork20 from "./assets/artworks/AnandamoyBanerji/batch3/AnandamoyBanerji_work20.jpg";
import abWork21 from "./assets/artworks/AnandamoyBanerji/batch3/AnandamoyBanerji_work21.jpg";
import abWork22 from "./assets/artworks/AnandamoyBanerji/batch3/AnandamoyBanerji_work22.jpg";

/* Batch 4 */
import abCover4 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_cover4.jpg";
import abWork23 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work23.jpg";
import abWork24 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work24.jpg";
import abWork25 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work25.jpg";
import abWork26 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work26.jpg";
import abWork27 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work27.jpg";
import abWork28 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work28.jpg";
import abWork29 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work29.jpg";
import abWork30 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work30.jpg";
import abWork31 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work31.jpg";
import abWork32 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work32.jpg";
import abWork33 from "./assets/artworks/AnandamoyBanerji/batch4/AnandamoyBanerji_work33.jpg";

/* Batch 5 */
import abCover5 from "./assets/artworks/AnandamoyBanerji/batch5/AnandamoyBanerji_cover5.jpg";
import abWork34 from "./assets/artworks/AnandamoyBanerji/batch5/AnandamoyBanerji_work34.jpg";
import abWork35 from "./assets/artworks/AnandamoyBanerji/batch5/AnandamoyBanerji_work35.jpg";
import abWork36 from "./assets/artworks/AnandamoyBanerji/batch5/AnandamoyBanerji_work36.jpg";

/* Batch 6 */
import abCover6 from "./assets/artworks/AnandamoyBanerji/batch6/AnandamoyBanerji_cover6.jpg";
import abWork37 from "./assets/artworks/AnandamoyBanerji/batch6/AnandamoyBanerji_work37.jpg";
import abWork38 from "./assets/artworks/AnandamoyBanerji/batch6/AnandamoyBanerji_work38.jpg";
import abWork39 from "./assets/artworks/AnandamoyBanerji/batch6/AnandamoyBanerji_work39.jpg";

/* Batch 7 */
import abCover7 from "./assets/artworks/AnandamoyBanerji/batch7/AnandamoyBanerji_cover7.jpg";
import abWork40 from "./assets/artworks/AnandamoyBanerji/batch7/AnandamoyBanerji_work40.jpg";
import abWork41 from "./assets/artworks/AnandamoyBanerji/batch7/AnandamoyBanerji_work41.jpg";
import abWork42 from "./assets/artworks/AnandamoyBanerji/batch7/AnandamoyBanerji_work42.jpg";
import abWork43 from "./assets/artworks/AnandamoyBanerji/batch7/AnandamoyBanerji_work43.jpg";

/* Batch 8 */
import abCover8 from "./assets/artworks/AnandamoyBanerji/batch8/AnandamoyBanerji_cover8.jpg";
import abWork44 from "./assets/artworks/AnandamoyBanerji/batch8/AnandamoyBanerji_work44.jpg";
import abWork45 from "./assets/artworks/AnandamoyBanerji/batch8/AnandamoyBanerji_work45.jpg";
import abWork46 from "./assets/artworks/AnandamoyBanerji/batch8/AnandamoyBanerji_work46.jpg";
import abWork47 from "./assets/artworks/AnandamoyBanerji/batch8/AnandamoyBanerji_work47.jpg";
import abWork48 from "./assets/artworks/AnandamoyBanerji/batch8/AnandamoyBanerji_work48.jpg";

/* =========================
   Artist 5 – Rajshree Pawar
   ========================= */

import rajshreeCover from "./assets/artworks/RajshreePawar/RajshreePawar_cover.jpeg";
import rajshreeWork1 from "./assets/artworks/RajshreePawar/RajshreePawar_work1.jpeg";
import rajshreeWork2 from "./assets/artworks/RajshreePawar/RajshreePawar_work2.jpg";

/* =========================
   Artist 6 – Vazda Khan
   ========================= */

import vazdaCover from "./assets/artworks/VazdaKhan/VazdaKhan_cover.jpeg";
import vazdaWork1 from "./assets/artworks/VazdaKhan/VazdaKhan_work1.jpeg";
import vazdaWork2 from "./assets/artworks/VazdaKhan/VazdaKhan_work2.jpeg";
import vazdaWork3 from "./assets/artworks/VazdaKhan/VazdaKhan_work3.jpeg";
import vazdaWork4 from "./assets/artworks/VazdaKhan/VazdaKhan_work4.jpg";

/* =========================
   Artist 7 – Simmi Khanna
   ========================= */

import simmiCover from "./assets/artworks/SimmiKhanna/SimmiKhanna_cover.jpg";
import simmiWork1 from "./assets/artworks/SimmiKhanna/SimmiKhanna_work1.jpg";
import simmiWork2 from "./assets/artworks/SimmiKhanna/SimmiKhanna_work2.jpg";
import simmiWork3 from "./assets/artworks/SimmiKhanna/SimmiKhanna_work3.jpg";
import simmiWork4 from "./assets/artworks/SimmiKhanna/SimmiKhanna_work4.jpg";

/* =========================
   Artist 8 – Nivedita Pande
   ========================= */

import niveditaCover from "./assets/artworks/NiveditaPande/NiveditaPande_cover.jpg";
import niveditaWork1 from "./assets/artworks/NiveditaPande/NiveditaPande_work1.jpg";
import niveditaWork2 from "./assets/artworks/NiveditaPande/NiveditaPande_work2.jpg";
import niveditaWork3 from "./assets/artworks/NiveditaPande/NiveditaPande_work3.jpg";
import niveditaWork4 from "./assets/artworks/NiveditaPande/NiveditaPande_work4.jpg";

/* =========================
   Artist 9 – Madan Lal
   ========================= */

import madanCover from "./assets/artworks/MadanLal/MadanLal_cover.jpg";
import madanWork1 from "./assets/artworks/MadanLal/MadanLal_work1.jpg";
import madanWork2 from "./assets/artworks/MadanLal/MadanLal_work2.jpg";
import madanWork3 from "./assets/artworks/MadanLal/MadanLal_work3.jpg";
import madanWork4 from "./assets/artworks/MadanLal/MadanLal_work4.jpg";
import madanWork5 from "./assets/artworks/MadanLal/MadanLal_work5.jpg";

/* =========================
   Artist 10 – RP Verma
   ========================= */

import rpvermaCover from "./assets/artworks/RPVerma/RPVerma_cover.jpg";
import rpvermaWork1 from "./assets/artworks/RPVerma/RPVerma_work1.jpg";
import rpvermaWork2 from "./assets/artworks/RPVerma/RPVerma_work2.jpg";

/* =========================
   EXPORT
   ========================= */

const artists = [
  {
    name: "Renuka Sondhi",
    cover: renukaCover,
    works: [
      renukaWork1, renukaWork2, renukaWork3, renukaWork4,
      renukaWork5, renukaWork6, renukaWork7, renukaWork8,
      renukaWork9, renukaWork10, renukaWork11,
    ],
  },
  {
    name: "Alka Jhamb",
    cover: alkaCover,
    works: [alkaWork1, alkaWork2, alkaWork3, alkaWork4],
  },
  {
    name: "Satish Sharma",
    cover: satishCover,
    works: [satishWork1, satishWork2, satishWork3, satishWork4],
  },
  {
    name: "Anandamoy Banerji",
    cover: abCover1,
    batches: [
      { cover: abCover1, works: [abWork1, abWork2, abWork3, abWork4, abWork5, abWork6, abWork7, abWork8, abWork9] },
      { cover: abCover2, works: [abWork10, abWork11, abWork12, abWork13, abWork14, abWork15, abWork16, abWork17, abWork18] },
      { cover: abCover3, works: [abWork19, abWork20, abWork21, abWork22] },
      { cover: abCover4, works: [abWork23, abWork24, abWork25, abWork26, abWork27, abWork28, abWork29, abWork30, abWork31, abWork32, abWork33] },
      { cover: abCover5, works: [abWork34, abWork35, abWork36] },
      { cover: abCover6, works: [abWork37, abWork38, abWork39] },
      { cover: abCover7, works: [abWork40, abWork41, abWork42, abWork43] },
      { cover: abCover8, works: [abWork44, abWork45, abWork46, abWork47, abWork48] },
    ],
  },
  {
    name: "Rajshree Pawar",
    cover: rajshreeCover,
    works: [rajshreeWork1, rajshreeWork2],
  },
  {
    name: "Vazda Khan",
    cover: vazdaCover,
    works: [vazdaWork1, vazdaWork2, vazdaWork3, vazdaWork4],
  },
  {
    name: "Simmi Khanna",
    cover: simmiCover,
    works: [simmiWork1, simmiWork2, simmiWork3, simmiWork4],
  },
  {
    name: "Nivedita Pande",
    cover: niveditaCover,
    works: [niveditaWork1, niveditaWork2, niveditaWork3, niveditaWork4],
  },
  {
    name: "Madan Lal",
    cover: madanCover,
    works: [madanWork1, madanWork2, madanWork3, madanWork4, madanWork5],
  },
  {
    name: "RP Verma",
    cover: rpvermaCover,
    works: [rpvermaWork1, rpvermaWork2],
  },
];

export default artists;
